import axios from "axios";
import { removeCookie } from "../context/useCookies";

let backendUrl = `https://dev-eyision.jamsara.com/api/v1/`;

export function authHeader() {
  let user = JSON.parse(window.sessionStorage.getItem("accessToken"));
  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}

export function logoutFunction() {
  removeCookie("accessToken");
  removeCookie("eyisionAdmin");

  window.location.replace("/login");
  window.location.reload();
}

export const headerForPublicAPI = new Headers({
  "Content-Type": "application/json",
});

export const headerForPrivateAPI = new Headers({
  "Content-Type": "application/json",
  Authorization: authHeader().Authorization,
});

export const headerForPrivateMediaAPI = new Headers({
  "Content-Type": "multipart/form-data",
  Authorization: authHeader().Authorization,
});

export const APIcallFunction = async (credentials) => {
  const requestOptions = {
    method: credentials.method,
    headers: credentials.header,
    body: JSON.stringify(credentials.body),
  };
  try {
    const response = await fetch(
      `${backendUrl}/v1${credentials.endPoint}`,
      requestOptions
    );

    const responseData = await handleResponse(response);

    return {
      data: responseData.data,
    };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const APIcallFunctionForImage = async (credentials) => {
  try {
    const endpointUrl = `${backendUrl}` + credentials.endPoint;
    const headers = {
      Authorization: authHeader().Authorization,
      "Content-Type": "multipart/form-data",
    };
    const response = await axios.post(endpointUrl, credentials.body, {
      headers,
    });

    return {
      data: response.data,
    };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        logoutFunction();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    if (data.error) {
      if (data.code === 3) {
        logoutFunction();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

export const role =
  JSON.parse(window.sessionStorage.getItem("adminuser"))?.roleId || 0;
const configPermissions =
  JSON.parse(window.sessionStorage.getItem("adminuser"))?.config || {};

export function checkConfigPermissions(key) {
  if (role === 1) {
    if (configPermissions.hasOwnProperty(key)) {
      return configPermissions[key];
    } else {
      return false;
    }
  } else {
    return true;
  }
}

export function generateOptions(step = 10, max = 50) {
  return Array.from({ length: max / step }, (_, i) => {
    const value = (i + 1) * step;
    return { value: value.toString(), label: `Show ${value}` };
  });
}
